import NodataIcon from '@/components/Icon/Nodata';
import NoSearchDataIcon from '@/components/Icon/NoSearchData';

const NoData = ({ text, type = 'nodata' }: { text?: string; type?: 'nodata' | 'nosearchdata' }) => {
  return (
    <div className="absolute left-[50%] top-[50%] flex w-[330px] translate-x-[-50%] translate-y-[-50%] flex-col items-center">
      {type === 'nodata' && <NodataIcon />}
      {type === 'nosearchdata' && <NoSearchDataIcon />}
      {!!text && <p className="mt-[20px] text-[#8D8FA6]">{text}</p>}
    </div>
  );
};

export default NoData;
